export async function fetchUserArticleList(
  userId: string | number,
  aid = 0
): Promise<Post.Info[]> {
  return http
    .get<Post.Info[]>('/v1/article/user_list', {
      user_id: Number(userId),
      aid
    })
    .then((res) => res.data)
    .catch(() => [])
}
